let StorageTopNewsApp = {};

function get(){
    return StorageTopNewsApp;
}
function set(value){
    StorageTopNewsApp = value;
}

export {get, set} 